import { Employee } from "../../../types/ganttChart";
import ganttChartStyles from "../../../styles/ganttChart/ganttChart.module.css";
import { ganttChartVerticalValues } from "../../../utils/ganttChartValues";
import VerticalTitleTextRowLock from "./VerticalTitleTextRowLock";
import VerticalOverlayForBlockedShift from "./VerticalOverlayForBlockedShift";
import { useSolutionPlanView } from "../../../hooks/useSolutionPlanView";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { openDrawer } from "../../../store/drawer";
import { ReactComponent as EditedEmployeeIcon } from "../../../assets/icons/warning_yellow.svg";
import labels from "../../../utils/labels";

const VerticalTitleTextRow = ({
  title,
  employees,
  solutionType,
}: {
  title: string;
  employees: Employee[];
  solutionType: "Nexus" | "Pondoo";
}) => {
  const { verticalColumnWidth, unplannedColumnWidth, selectedGanttChartTab } =
    useAppSelector((state) => state.ganttChartSlice);
  const widthWithoutLock =
    verticalColumnWidth - 25 > 0 ? verticalColumnWidth - 25 : 0;
  const { isDrawerOpen } = useAppSelector((state) => state.drawerSlice);
  const selectedEmployeeShiftId = useAppSelector(
    (state) => state.drawerSlice.selectedEmployee?.employeeShiftId,
  );
  const { manualEdits } = useAppSelector(
    (state) => state.employeeSettingsSlice,
  );
  const dispatch = useAppDispatch();

  // Dynamic display state given the user's selection of filter and date
  const planViewState = useSolutionPlanView();

  const isEmployeeDrawerShown = true;

  const openEmployeeDrawer = (employee: Employee): void => {
    dispatch(
      openDrawer({
        type: "Employee",
        drawerContent: {
          employeeShiftId: employee.shiftSchedule.idShift,
        },
      }),
    );
  };

  return (
    <div
      className={ganttChartStyles.verticalColumnTextItemsWrapper}
      style={{
        transition: "ease-in",
        position: "sticky",
        top: "27px",
      }}
    >
      <div
        className={ganttChartStyles.columnTitleCell}
        style={{
          height:
            ganttChartVerticalValues.verticalViewTextRowHeight.toString() +
            "px",
        }}
      >
        <p>{title}</p>
      </div>
      <div
        className={ganttChartStyles.verticalTitleTextRow}
        style={{
          opacity: 1,
          width: unplannedColumnWidth + "px",
          minWidth: unplannedColumnWidth + "px",
        }}
        key={`VerticalTitleTextRow-0`}
      >
        <p>Uplanlagte</p>
      </div>
      {employees.map((employee, index) => (
        <div
          className={`
            ${ganttChartStyles.verticalTitleTextRow} 
            ${isDrawerOpen && selectedEmployeeShiftId === employee.shiftSchedule.idShift && ganttChartStyles.verticalTitleTextRowOpen}
            `}
          style={{
            opacity: 1,
            width: verticalColumnWidth + "px",
            minWidth: verticalColumnWidth + "px",
          }}
          key={`VerticalTitleTextRow-${index + 1}`}
        >
          {isEmployeeDrawerShown && selectedGanttChartTab === "Original" ? (
            <button
              type="button"
              className={ganttChartStyles.verticalTitleEmployeeButton}
              aria-label={labels.openEmployeeDrawer(employee.fullName)}
              onClick={() => openEmployeeDrawer(employee)}
            >
              <VerticalOverlayForBlockedShift employee={employee} />
              <p
                title={employee.fullName}
                style={{ width: widthWithoutLock + "px" }}
              >
                {employee.fullName}
              </p>
              {(employee.hasManualShiftChanges ||
                manualEdits[employee.shiftSchedule.idShift]) && (
                <EditedEmployeeIcon />
              )}
            </button>
          ) : (
            <>
              <VerticalOverlayForBlockedShift employee={employee} />
              <p
                title={employee.fullName}
                style={{ width: widthWithoutLock + "px" }}
              >
                {employee.fullName}
              </p>
              {(employee.hasManualShiftChanges ||
                manualEdits[employee.shiftSchedule.idShift]) && (
                <EditedEmployeeIcon />
              )}
            </>
          )}
          <VerticalTitleTextRowLock
            employee={employee}
            solutionType={solutionType}
            planViewState={planViewState}
          />
        </div>
      ))}
    </div>
  );
};

export default VerticalTitleTextRow;
